// 不能引入 i18next：服务端中间件和请求层也依赖本模块，引入会在服务端触发 i18next.init()

export const DEFAULT_LANGUAGE = 'zh-CN'
export const LANGUAGE_STORAGE_KEY = 'locales'
// App / deviceinfo.h_lang 使用的标准语言码
export const SUPPORTED_LANGUAGES = ['zh-rHK', 'zh-rTW', 'zh-CN', 'en']

// i18next 会把 zh-rHK / zh-rTW 格式化成 zh-RHK / zh-RTW，需映射回真实目录名
const LANGUAGE_FOLDER_MAP: Record<string, string> = {
  'zh-rHK': 'zh-rHK',
  'zh-RHK': 'zh-rHK',
  'zh-rTW': 'zh-rTW',
  'zh-RTW': 'zh-rTW',
  'zh-CN': 'zh-CN',
  'zh-cn': 'zh-CN',
  en: 'en',
}

export const normalizeLanguage = (language?: string | null) => {
  if (!language) {
    return null
  }

  return LANGUAGE_FOLDER_MAP[language] || null
}

// 需与 i18n/index.ts 中语言包 import 的 webpackChunkName 保持一致
export const getLocaleChunkName = (
  language: string,
  namespace = 'translation'
) => `locale-${language}-${namespace}-json`

const parseDeviceInfo = (rawDeviceInfo?: string | null) => {
  if (!rawDeviceInfo) {
    return null
  }

  try {
    // URLSearchParams.get 已完成一次 decode，与项目内 deviceInfo 解析保持一致，避免二次 decode
    return JSON.parse(rawDeviceInfo)
  } catch (error) {
    try {
      return JSON.parse(decodeURIComponent(rawDeviceInfo))
    } catch (fallbackError) {
      return null
    }
  }
}

export const resolveLanguage = ({
  rawDeviceInfo,
  queryLanguage,
  localLanguage,
}: {
  rawDeviceInfo?: string | null
  queryLanguage?: string | null
  localLanguage?: string | null
}) =>
  normalizeLanguage(parseDeviceInfo(rawDeviceInfo)?.h_lang) ||
  normalizeLanguage(queryLanguage) ||
  normalizeLanguage(localLanguage) ||
  DEFAULT_LANGUAGE

// 旧 WebView / 禁用存储时访问 localStorage 会抛 SecurityError，不能让它中断启动
export const readStoredLanguage = () => {
  try {
    return window.localStorage.getItem(LANGUAGE_STORAGE_KEY)
  } catch (error) {
    return null
  }
}

export const writeStoredLanguage = (language: string) => {
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language)
  } catch (error) {
    // 存储不可用时只是不缓存语言
  }
}

export const getCurrentLanguage = () => {
  if (typeof window === 'undefined') {
    return DEFAULT_LANGUAGE
  }

  const searchParams = new URLSearchParams(window.location.search)
  return resolveLanguage({
    // App WebView 传参统一为小写 deviceinfo，兼容历史 camelCase 写法
    rawDeviceInfo:
      searchParams.get('deviceinfo') || searchParams.get('deviceInfo'),
    queryLanguage: searchParams.get('lang'),
    localLanguage: readStoredLanguage(),
  })
}
